<template>
  <div>
    <v-row>
      <v-col cols="12" class="mb-8">
        <h4 class="font-weight-bold" style="color: #1c1f4c !important;">
          {{ titulo }}
        </h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :sm="$vuetify.breakpoint.width < 745 ? 12 : 6" md="4">
        <v-text-field v-model="buscar" label="Buscar" placeholder="Buscar" class="rounded-xl" rounded outlined dense hide-details append-icon="mdi-magnify"></v-text-field>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.width < 348 ? 12 : 6" :sm="$vuetify.breakpoint.width < 745 ? 6 : 3" md="4">
        <div class="d-flex" :class="[
          $vuetify.breakpoint.width < 348 ? 'justify-center' : 'justify-start',
          $vuetify.breakpoint.width < 300 ? 'flex-column' : 'flex-row'
        ]">
          <v-btn class="lowercase-text px-4 mr-2" :class="[ $vuetify.breakpoint.width < 300 ? 'mb-4' : '' ]" color="primary" style="text-transform: none !important" rounded
            :block="$vuetify.breakpoint.width < 300 ? true : false" @click="filtrar()">
            Buscar
          </v-btn>
          <v-btn class="lowercase-text px-4" color="primary" style="text-transform: none !important" rounded outlined
            :block="$vuetify.breakpoint.width < 300 ? true : false" @click="limpiar()">
            Limpiar
          </v-btn>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.width < 348 ? 12 : 6" :sm="$vuetify.breakpoint.width < 745 ? 6 : 3" md="4">
        <div class="d-flex" :class="[
          $vuetify.breakpoint.width < 348 ? 'justify-center' : 'justify-end',
          $vuetify.breakpoint.width < 300 ? 'flex-column' : 'flex-row'
        ]">
          <slot name="btnOptions" />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <Table
          :items="listado"
          :headers="headers"
          :slots-column="['action']"
          :por_pagina="paginacion.por_pagina"
          :page="paginacion.pagina"
          :total-registros="paginacion.total_registro"
          @paginationChange="setPaginacion"
          @cambioPorPagina="cambioPorPagina"
        >
          <template #[`action`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="verDetalle(item)">
                    <v-icon color="primary">mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalle</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="verEvaluaciones(item)">
                    <v-icon color="primary">mdi-file-document-check-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver evaluaciones</span>
              </v-tooltip>
              <slot name="btnAccionIcono" :item="item" />
            </div>
          </template>          
        </Table>
      </v-col>
    </v-row>
      <!-- Modal Evaluaciones -->
      <AppDialog 
        title="Evaluaciones del candidato" 
        v-model="evaluacionesModal" 
        max-width="900"
      >
        <template #body>
          <TableEvaluacion
            :headers="headersEvaluaciones"
            :items="evaluaciones"
            :totalRegistros="evaluaciones.length"
            :por_pagina="evaluaciones.length || 10"
            :page="1"
            :sinPaginacion="true"
            :mostrar-resumen-puntaje="false"
          >
          </TableEvaluacion>
        </template>
        <template #actions>
          <v-row justify="center" class="my-4">
            <v-btn
              color="primary"
              class="rounded-xl"
              style="text-transform: none"
              outlined
              @click="evaluacionesModal = false"
            >Cerrar</v-btn>            
          </v-row>
        </template>
      </AppDialog>
    <!-- Modal Detalle  -->
    <ModalDetalleCandidato :visible.sync="candidatoModal"
        :person-data="personData"
        :personal-data="personalData" />
  </div>
</template>

<script>
import Table from "../../../../solicitudes/components/Table.vue";
import TableEvaluacion from "./TableEvaluacion.vue"
import ModalDetalleCandidato from "../../../../candidatos-no-contratados/components/ModalDetalleCandidato.vue";

export default {
  name: "TablaCandidatosBolson",
  components: {
    Table,
    TableEvaluacion,
    ModalDetalleCandidato
  },
  props: {
    titulo: {
      type: String,
      default: ""
    },
    paginacion: {
      type: Object,
      default: () => ({
        pagina: 1,
        por_pagina: 5,
        total_registro: 1
      })
    },
    listado: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      //Busqueda
      buscar: null,
      //Tabla
      headers: [
        {
          text: "Número de documento",
          value: "numero_documento",
          sortable: false,
          align: "center",
        },
        {
          text: "Tipo de documento",
          value: "tipo_documento",
          sortable: false,
          align: "start",
        },
        {
          text: "Nombres",
          value: "nombres",
          sortable: false,
          align: "start",
        },
        {
          text: "Apellidos",
          value: "apellidos",
          sortable: false,
          align: "start",
        },
        {
          text: "Plaza seleccionada",
          value: "plaza_seleccionada",
          sortable: false,
          align: "start",
        },
        {
          text: "Número de teléfono",
          value: "numero_telefono",
          sortable: false,
          align: "start",
        },
        {
          text: "Promedio de evaluación",
          value: "promedio_evaluacion",
          sortable: false,
          align: "center",          
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          align: "center",
        },
      ],
      //Modales
      //DETALLE CANDIDATOS
      candidatoModal: false,
      personData: null,
      personalData: [],
      //EVALUACIONES
      evaluacionesModal: false,
      evaluaciones: [],
    }
  },
  computed: {
    headersEvaluaciones() {
      return [
        { text: "Nombre de evaluación", align: "left", value: "nombre", sortable: false },
        { text: "Evaluador", align: "left", value: "evaluador", sortable: false },
        { text: "Puntaje", align: "center", value: "puntaje", sortable: false },
      ];
    }
  },
  methods: {
    verDetalle(item) {
      this.personData = {
        nombre: `${item.nombres || ''} ${item.apellidos || ''}`.trim() || '-',
        avatar: null
      };

      this.personalData = [
        { label: 'Tipo documento', value: item.tipo_documento || '-' },
        { label: 'No. de documento', value: item.numero_documento || '-' },
        { label: 'País de nacimiento', value: item.pais_nacimiento || '-' },
        { label: 'Fecha de nacimiento', value: item.fecha_nacimiento || '-' },
        { label: 'Teléfono personal', value: item.numero_telefono || '-' },
        { label: 'Departamento de residencia', value: item.departamento_residencia || '-' },
        { label: 'Distrito de residencia', value: item.distrito_residencia || '-' },
        { label: 'Dirección', value: item.direccion || '-' },
        { label: 'Email personal', value: item.email_personal || '-' },
      ];

      this.candidatoModal = true;
    },
    verEvaluaciones(item) {
      this.evaluaciones = item.evaluaciones || [];
      this.evaluacionesModal = true;
    },
    filtrar() {
      this.paginacion.pagina = 1;
      this.$emit('filtrar', {
        buscar: this.buscar,
        pagina: 1,
      });
    },
    limpiar() {
      this.buscar = null;
      this.paginacion.pagina = 1;
      this.$emit('limpiar', {
        buscar: this.buscar,
        pagina: 1,
      });
    },
    async setPaginacion(page) {
      this.paginacion.pagina = page;
      this.$emit('cambio-pagina', page);
    },
    async cambioPorPagina(por_pagina) {
      this.paginacion.por_pagina = por_pagina;
      this.paginacion.pagina = 1;
      this.$emit('cambio-por-pagina', {
        por_pagina,
        pagina: 1
      });
    },
  },
  created() {
  },
};
</script>
